import { Form as AntForm } from 'antd';
import styled from 'styled-components';

import { Label } from '@atom/form/label/label';

export const Form = styled(AntForm)`
  width: 100%;

  display: grid;
  gap: 7px;

  & .ant-form-item {
    margin: 0;
  }
` as typeof AntForm;

Form.Item = Label as any;
Form.List = AntForm.List;
Form.useWatch = AntForm.useWatch;
